import PbAjax from './ajax';
import {decodeData} from './pbdecoder';
import lang from '../../../lang/index';

const cache = UpSDK.cache;

/**
 * pb请求数据
 * @param {Object} config pbajax 配置
 * @param {Object} params 参数
 * @param {Object} pbObj 解析加密参数的pd对象
 */
function baseAjax(config, params, pbObj) {
    let data = params;
    if (pbObj.Request) {
        data = new pbObj.Request(params);
    }
    const pbajax = new PbAjax();
    const user = cache.getCache('user') || {};
    // console.log(`%c 请求参数 ${config.api}`, 'color:blue', data);

    return new Promise((resolve, reject) => {
        pbajax.do(
            $.extend(true, {
                header: {
                    userToken: user.userToken,
                    'Accept-Language': lang.type || 'en-US'
                }
            }, config),
            data,
            (resp) => {
                const {code, result} = decodeData(resp, pbObj, config.api);

                if (code === 1) {
                    return resolve(result);
                }

                if (result) {
                    return reject({code, data: result});
                }

                // 判断登录
                return reject({code, data: null});
            },
            () => {
                reject({code: -1, data: null});
            },
            () => {
                reject({code: -2, data: null});
            }
        );
    });
}

/**
 * @description 一个使用服务提供的柯里化函数，可以通过下面函数生成不同用途的函数
 * 1、下面创建一个统一的服务
 * const ugMallService = serviceFactory('ugmall');
 * 2、实例化一个方法
 * const getUgMallRanking = ugMallService('/ug/mall/ranking/list', UgMallRankingPb.UG.Mall.Ranking);
 * 3、开始调用方法
 * getUgMallRanking(params).then(data=>console.log(data)).catch(err=>console.log(err));
 *
 * 这样做的好处就是，每个地方不需要将所有的参数传递一遍，这样做的原因
 * 1、多个接口对应的是同一个服务，所以服务可以缓存
 * 2、定义方法的时候可以将请求参数无关的参数抽离，提取到每个文件的顶部，如果URL或者pb文件有变更，不需要在业务代码中到处找请求去修改
 *
 * @param {Object} service java对应的service名称，一般是php那边配置的
 * @param {String} urlPrefix URL 前缀
 * @returns {function({config?: *, header?: *, params?: *, pbObj?: *}=): *}
 */
function serviceFactory(service, urlPrefix = '') {
    /**
     * @param {String} api 请求url
     * @param {Object} pbObj 解析数据的pb对象
     * @param {Object} config pbajax中的附加config
     */
    return (api, pbObj, config = {}) => params => baseAjax(
        //  合并配置，注意这个true是深度合并
        $.extend(true, config, {service, api: urlPrefix + api}),
        //  请求参数
        params,
        //  加密解密的pb对象，包含Request和Response
        pbObj
    );
}

//  用户列表相关的Service
const userService = serviceFactory('service', '');

export {
    baseAjax,
    userService,
    serviceFactory
};



// WEBPACK FOOTER //
// ./src/js/openjs/deps/login/request/index.js